import * as React from "react"
import { cn } from "@/lib/utils"

export interface ContentTab {
  id: string
  label: string
  icon?: React.ReactNode
  count?: number
}

export interface ContentTabsProps {
  tabs: ContentTab[]
  activeTab: string
  onTabChange: (tabId: string) => void
  className?: string
}

export function ContentTabs({
  tabs,
  activeTab,
  onTabChange,
  className,
}: ContentTabsProps) {
  return (
    <div className={cn("flex gap-1 p-1 bg-gray-100/80 rounded-xl w-fit", className)}>
      {tabs.map((tab) => {
        const isActive = tab.id === activeTab
        return (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={cn(
              "flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-semibold transition-all duration-200",
              isActive
                ? "bg-white shadow-sm text-[color:var(--agent-accent)]"
                : "text-gray-600 hover:text-gray-900 hover:bg-white/50"
            )}
          >
            {tab.icon && (
              <span className={cn(
                "[&_svg]:w-4 [&_svg]:h-4",
                isActive ? "text-[color:var(--agent-accent)]" : "text-gray-500"
              )}>
                {tab.icon}
              </span>
            )}
            <span>{tab.label}</span>
            {tab.count !== undefined && (
              <span className={cn(
                "px-2 py-0.5 rounded-full text-xs font-bold",
                isActive
                  ? "bg-[color:var(--agent-accent)]/10 text-[color:var(--agent-accent)]"
                  : "bg-gray-200 text-gray-600"
              )}>
                {tab.count}
              </span>
            )}
          </button>
        )
      })}
    </div>
  )
}
